module.exports = __webpack_public_path__ + "static/media/siddharth-sweets.44d2b920.jpg";